import { render } from "./Visits.vue?vue&type=template&id=45117bc5&scoped=true"
import script from "./Visits.vue?vue&type=script&lang=js"
export * from "./Visits.vue?vue&type=script&lang=js"

import "./Visits.vue?vue&type=style&index=0&id=45117bc5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45117bc5"]])

export default __exports__